module.exports = __webpack_public_path__ + "static/media/logo-모자이크@2x.01f7cd80.png";